import { render, staticRenderFns } from "./flightDetails.vue?vue&type=template&id=70e0b136&"
import script from "./flightDetails.vue?vue&type=script&lang=ts&"
export * from "./flightDetails.vue?vue&type=script&lang=ts&"
import style0 from "./flightDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports